import { ROW_EXIT_TRANSITION } from './rowExit';

export const INBOX_TD_PADDING = 'px-3 first:pl-5 last:pr-4';
const INBOX_TH_PADDING = '!px-3 first:!pl-5 last:!pr-4';
// Padding, not a row min-height, sets the row height: padding can animate to zero as a row leaves.
const INBOX_CELL_CLASS = `${INBOX_TD_PADDING} py-2.5 transition-[padding] ${ROW_EXIT_TRANSITION}`;

export const INBOX_COLUMN_CHROME = {
    cellClassName: INBOX_CELL_CLASS,
    headerClassName: INBOX_TH_PADDING
} as const;

// Rows this close to the bottom open their menus upwards, like the communications table.
const DROP_UP_ROWS = 3;

export function opensUpwards(index: number, rowCount: number): boolean {
    return index >= rowCount - DROP_UP_ROWS;
}
